import Paper from "@material-ui/core/es/Paper/Paper";
import React from "react";

import ActionBar from "../components/ActionBar";
import FormView from "../components/FormView";
import Loader from "../components/Loader";
import * as API from "../util/api";
import * as Util from "../util/util";
import VLComponent from "./VLComponent";

class SettingScreen extends VLComponent {

    constructor() {
        super();
        this.state = {loaded: false, groups: []};
    }

    componentDidMount() {
        API.POST("account/getInfo", {sensor_id: this.props.id}, result => {
            Util.handleLogout(result);
            if (result.success) {
                let groups = result.result.groups;
                groups.forEach((g, i) => {
                    this.setState({["group" + (i + 1)]: g == null ? "" : g.name});
                });
                const newState = {...result.result, groups};
                this.setState(newState);
                this.setState({loaded: true});
            }
        });
    }

    render() {
        return (
            <div>
                <ActionBar title="Settings"/>
                {this.renderTextAlert()}
                <div id="content" style={{
                    display: this.state.loaded ? "flex" : "none",
                    maxHeight: "calc(100vh - 70px)",
                    padding: 24,
                    overflowY: "auto",
                    justifyContent: "center"
                }}>
                    <Paper style={{
                        padding: 16,
                        borderRadius: 8,
                        width: "30cm",
                        maxWidth: "90vw",
                        maxHeight: "calc(100vh - 120px)",
                        overflowY: "auto"
                    }}>
                        <p>Signed in as {this.state.username}</p>
                        <p>Access Level: {Util.getAccessLevel(this.state.access_level)}</p>
                        <FormView items={this.getItems()} changeEvent={this.handleInputChange}/>
                    </Paper>
                </div>
                <Loader loaded={this.state.loaded}/>
            </div>
        );
    }

    save = () => {
        API.POST("groups/set", this.state, result => {
            if (result.success) {
                this.save2();
            } else {
                this.basicAlert(result.error);
            }
        });
    };

    save2 = () => {
        API.POST("account/setInfo", this.filterState(["twitter_default", "act_con_name", "alert_name", "warning_name"]), result => {
            if (result.success) {
                this.basicAlert("Your changes have been saved", Util.goBack);
            } else {
                this.basicAlert(result.error);
            }
        });
    };

    getItems = () => {
        let items = [{type: "title", text: "System Groups"}];

        for (let i = 0; i < 3; i++) {
            let id = "group" + (i + 1);
            items.push({id, name: "Group " + (i + 1), value: this.state[id], type: "text"});
        }

        items.push({type: "title", text: "Twitter"});
        items.push({id: "twitter_default", name: "Default Twitter", value: this.state.twitter_default, type: "text"});

        items.push({type: "title", text: "Alarm Levels"});
        items.push({id: "act_con_name", name: "Level 1", value: this.state.act_con_name, type: "text"});
        items.push({id: "alert_name", name: "Level 2", value: this.state.alert_name, type: "text"});
        items.push({id: "warning_name", name: "Level 3", value: this.state.warning_name, type: "text"});

        items.push({type: "button", text: "save", onClick: this.save});

        return items;
    };

}

export default SettingScreen;